import FETCH from "../utils/fetch";
import ROUTES from "../config/routes";
import axios from "axios";

const fetchAll = async (params) => {
  const { history, pageNum, limit } = params;

  // console.log("params", params);

  let res = await FETCH.get({
    url: ROUTES.FETCH_ALL_MODULES,
    id: `?pageNum=${pageNum}&limit=${limit}`,
    history: history,
  });
  return res;
};

const fetchFaq = async () => {
  let res = await FETCH.get({
    url: ROUTES.FETCH_FAQ,
  });
  return res;
};

const addProperty = async (params) => {
  const { moduleName, pageNum, limit, body, id } = params;

  console.log("params", params, body);

  let res = await FETCH.post({
    url: ROUTES.CRETE_CLIENT_ITEM,
    id: `?module=${moduleName}`,
    body,
  });
  return res;
};

const fetchRooms = async (params) => {
  const { moduleName, pageNum, limit, id, body } = params;
  let res = await FETCH.get({
    url: ROUTES.FETCH_ALL_ROOMS,
    id: `?recordId=${id}`,
    body,
  });
  return res;
};

const fetchDetails = async (id) => {
  let res = await FETCH.get({
    url: ROUTES.FETCH_ALL_ROOMS,
    id: `?recordId=${id}`,
  });
  return res;
};

const fetchItems = async (params) => {
  const { moduleName, pageNum, limit, body } = params;
  // console.log("params", params);
  let res = await FETCH.post({
    url: ROUTES.FETCH_ALL_ITEMS,
    id: `?module=${moduleName}&page=${pageNum}&limit=${limit}`,
    body,
  });
  return res;
};

const create = async (body) => {
  let res = await FETCH.post({
    url: `${ROUTES.CREATE_MODULE}?clientId=1`,
    body,
  });
  return res;
};

const update = async (id, body) => {
  let res = await FETCH.put({
    url: ROUTES.UPDATE_MODULE,
    body,
    id,
  });
  return res;
};

const fetchAttributes = async (module) => {
  let res = await FETCH.post({
    url: `${ROUTES.MODULE_ATTRIBUTES}?module=${module}`,
    body: {},
  });
  return res;
};

const createClientItem = async (module, body) => {
  let res = await FETCH.post({
    url: `${ROUTES.CRETE_CLIENT_ITEM}?module=${module}`,
    body,
  });
  return res;
};

const updateClientItem = async (recordId, body) => {
  let res = await FETCH.put2({
    url: `${ROUTES.UPDATE_CLIENT_ITEM}?recordId=` + recordId,
    body,
  });
  return res;
};

const getRecordTotal = async (recordId, body) => {
  let res = await FETCH.post({
    url: `${ROUTES.RECORD_TOTAL}?recordId=${recordId}`,
    body,
  });
  return res;
};

const deleteItem = async (body) => {
  let res = await FETCH.deletee({
    url: `${ROUTES.DELETE_ITEM}`,
    body,
  });
  return res;
};

const removeModuleAttribute = async (body) => {
  let res = await FETCH.post({
    url: `${ROUTES.REMOVE_MODULE_ATTRIBUTES}?clientId=1`,
    body,
  });
  return res;
};

const uploadImage = async (form) => {
  let res = await FETCH.post({
    url: `${ROUTES.IMAGE_UPLOAD}`,
    body: form,
    isFormData: true,
  });
  return res;
};
const uploadFile = async (form) => {
  console.log("form>>>", form);
  let res = await FETCH.post({
    url: `${ROUTES.POST_VIDEO}`,
    body: JSON.stringify(form),
    isFormData: true,
  });
  return res;
};
const uploadURL = async (url, body, header) => {
  console.log("url", url);
  console.log("body", body);
  let res = await FETCH.put1({
    url,
    body,
    header,
    // isFormData: true,
  });
  return res;
};
const swapCollectibles = async (body) => {
  let res = await FETCH.post({
    url: `${ROUTES.SWAP_COLLECTIBLES}`,
    body,
  });
  return res;
};

const removeClientModule = async (body) => {
  let res = await FETCH.deletee({
    url: `${ROUTES.DELETE_ITEM}`,
    body,
  });
  return res;
};

const updateClientModule = async (recordId, body) => {
  try {
    let res = await FETCH.put2({
      url: `${ROUTES.UPDATE_CLIENT_ITEM}?recordId=` + recordId,
      body,
    });
    return res;
  } catch (error) {
    console.log("error in axios put");
  }
};
const assetFiledDetails = async (assetName) => {
  try {
    let res = await FETCH.post({
      url: `${ROUTES.ASSET_FIELDS}?module=${assetName}`,
    });
    return res;
  } catch (error) {
    console.log("error in axios put");
  }
};

const addAsset = async (module, body) => {
  try {
    let res = await FETCH.post({
      url: `${ROUTES.CRETE_CLIENT_ITEM}?module=${module}`,
      body,
    });
    return res;
  } catch (error) {
    console.log("error in axios addAsset", error);
  }
};

const assetAllocation = async () => {
  try {
    let res = await FETCH.get({
      url: `${ROUTES.FETCH_ALL_ASSET_ALLOCATION}`,
    });
    return res;
  } catch (error) {
    console.log("error in axios put");
  }
};
const insuraceAllocation = async (name) => {
  try {
    let res = await FETCH.get({
      // url: `${ROUTES.FETCH_ALL_ASSET_ALLOCATION}`,
      url: `${ROUTES.FETCH_ALL_ASSET_ALLOCATION}?module=${name}`,
    });
    return res;
  } catch (error) {
    console.log("error in axios put");
  }
};

const getTransactionsData = async (id) => {
  try {
    let res = await FETCH.get({
      url: `${`client-module-service/lability-transaction`}?itemId=${id}`,
    });
    return res;
  } catch (error) {
    console.log("error in axios put");
  }
};
const getPayOffData = async () => {
  try {
    let res = await FETCH.get({
      url: `${`client-module-service/payoff`}`,
    });
    return res;
  } catch (error) {
    console.log("error in axios put");
  }
};

const createPayOffData = async (body) => {
  try {
    let res = await FETCH.post({
      url: `${`client-module-service/payoff`}`,
      body,
    });
    return res;
  } catch (error) {
    console.log("error in axios put");
  }
};
const getOneTimeFunding = async () => {
  try {
    let res = await FETCH.get({
      url: `${`client-module-service/onetime-payment`}?page=1&limit=30`,
    });
    return res;
  } catch (error) {
    console.log("error in axios put");
  }
};
const createOneTimePayment = async (body) => {
  let res = await FETCH.post({
    url: `${`client-module-service/onetime-payment`}`,
    body,
  });
  return res;
};

const UpdateOneTimePayment = async (body) => {
  let res = await FETCH.put2({
    url: `${`client-module-service/onetime-payment`}`,
    body,
  });
  return res;
};
const DeleteOneTimePayment = async (id) => {
  let res = await FETCH.deletee({
    url: `${`client-module-service/onetime-payment`}?id=${id}`,
  });
  return res;
};
const UpdateAssetGoal = async (body) => {
  let res = await FETCH.put2({
    url: `${ROUTES.UPDATE_ASSET_GOAL}`,
    body,
  });
  return res;
};
const deleteAssetGoal = async (body) => {
  let res = await FETCH.put2({
    url: `${ROUTES.DELETE_GOAL}`,
    body,
  });
  return res;
};
const removeAssignedAsset = async (body) => {
  let res = await FETCH.post({
    url: `${ROUTES.REMOVE_ASSIGN_ASSET}`,
    body,
  });
  return res;
};
const assignAsset = async (body) => {
  let res = await FETCH.post({
    url: `${ROUTES.ASSIGN_ASSET}`,
    body,
  });
  return res;
};
const fetchSingleGoalDetails = async (id) => {
  let res = await FETCH.get({
    url: ROUTES.FETCH_SINGLE_GOAL,
    id: `?recordId=${id}`,
  });
  return res;
};
const updateAssignAsset = async (body) => {
  let res = await FETCH.post({
    url: `${ROUTES.UPDATE_ASSIGN_ASSET}`,
    body,
  });
  return res;
};
const refreshAssetModule = async () => {
  try {
    let res = await FETCH.get({
      url: `${`plaid-service/asset/refresh`}`,
    });
    return res;
  } catch (error) {
    console.log("error in axios put");
  }
};
const assetRefreshCount = async (endpoint) => {
  try {
    let res = await FETCH.get({
      url: `${`plaid-service/request/count?endPoint=${endpoint}`}`,
    });
    return res;
  } catch (error) {
    console.log("error in axios put");
  }
};
const getMonetaryValue = async (date) => {
  let res = await FETCH.post({
    url: `${ROUTES.GET_ASSET_MONETARY_VALUE}?currentDate=${date}`,
  });
  return res;
};
const getTransactionExpanses = async (startDate, endDate) => {
  let res = await FETCH.get({
    url: `${ROUTES.GET_EXPANSES}?startDate=${startDate}&endDate=${endDate}`,
  });
  return res;
};
const getTopExpanses = async (body) => {
  let res = await FETCH.post({
    url: `${ROUTES.GET_TOP_EXPANSES}`,
    body: body,
  });
  return res;
};
const getFilterBudgets = async (startDate, endDate) => {
  let res = await FETCH.get({
    url: `${ROUTES.GET_FILTER_BUDGET}?startDate=${startDate}&endDate=${endDate}`,
  });
  return res;
};
const getFilterGoals = async (startDate, endDate) => {
  let res = await FETCH.get({
    url: `${ROUTES.GET_FILTER_GOALS}?startDate=${startDate}&endDate=${endDate}`,
  });
  return res;
};
const getSelectedMonetaryValue = async (date, body) => {
  let res = await FETCH.post({
    url: `${ROUTES.GET_ASSET_MONETARY_VALUE}?currentDate=${date}`,
    body,
  });
  return res;
};
const getDebt = async (startDate, endDate) => {
  let res = await FETCH.get({
    url: `${ROUTES.GET_FILTER_DEBT}?startDate=${startDate}&endDate=${endDate}`,
  });
  return res;
};
const postDebtData = async (id, body) => {
  let res = await FETCH.post({
    url: `${ROUTES.POST_DEBT_DATA}`,
    body,
  });
  return res;
};
const fetchModulesDocs = async (moduleName) => {
  let res = await FETCH.get({
    url: `${ROUTES.USER_ATTACHED_DOCS}?type=${moduleName}`,
  });
  return res;
};
const fetchUploadedModulesDocs = async (moduleName, page, otp) => {
  let res = await FETCH.get({
    url: `${ROUTES.GET_IMP_DOCUMENT}?type=${moduleName}&otp=${otp}&page=${page}&limit=40`,
  });
  return res;
};
const uploadModulesDocs = async (body) => {
  let res = await FETCH.post({
    url: `${ROUTES.UPLOAD_IMP_DOCUMENT}`,
    body,
  });
  return res;
};
const moveModulesDocs = async (id, body) => {
  let res = await FETCH.put2({
    url: `${ROUTES.UPDATE_IMP_DOCUMENT}?id=${id}`,
    body,
  });
  return res;
};
const deleteModulesDocs = async (id) => {
  let res = await FETCH.deletee({
    url: `${ROUTES.DELETE_IMP_DOCUMENT}?documentId=${id}`,
  });
  return res;
};
const fetchFutureLoans = async (page) => {
  let res = await FETCH.get({
    url: `${ROUTES.FETCH_FUTURE_LOAN}?page=${page}&limit=40`,
  });
  return res;
};
const fetchLiabilitySum = async (moduleName) => {
  let res = await FETCH.get({
    url: `${ROUTES.CALCULATE_LOAN_SUM}?type=${moduleName}`,
  });
  return res;
};
const fetchIncomeSum = async (startDate, endDate) => {
  let res = await FETCH.get({
    url: `${ROUTES.INCOME_TOTAL_SUM}?startDate=${startDate}&endDate=${endDate}`,
  });
  return res;
};
const fetchIncomeChartData = async (startDate, endDate, type) => {
  let res = await FETCH.get({
    url: type
      ? `${ROUTES.INCOME_CHART}?startDate=${startDate}&endDate=${endDate}&type=${type}`
      : `${ROUTES.INCOME_CHART}?startDate=${startDate}&endDate=${endDate}`,
  });
  return res;
};
const MODULE_API = {
  addProperty,
  fetchAll,
  fetchItems,
  create,
  update,
  fetchAttributes,
  removeModuleAttribute,
  uploadImage,
  swapCollectibles,
  fetchFaq,
  fetchRooms,
  removeClientModule,
  createClientItem,
  updateClientItem,
  updateClientModule,
  getRecordTotal,
  deleteItem,
  assetFiledDetails,
  addAsset,
  assetAllocation,
  uploadFile,
  uploadURL,
  fetchDetails,
  insuraceAllocation,
  getTransactionsData,
  getPayOffData,
  createOneTimePayment,
  createPayOffData,
  getOneTimeFunding,
  UpdateOneTimePayment,
  DeleteOneTimePayment,
  UpdateAssetGoal,
  deleteAssetGoal,
  removeAssignedAsset,
  assignAsset,
  fetchSingleGoalDetails,
  updateAssignAsset,
  refreshAssetModule,
  assetRefreshCount,
  getMonetaryValue,
  getTransactionExpanses,
  getTopExpanses,
  getFilterBudgets,
  getFilterGoals,
  getSelectedMonetaryValue,
  getDebt,
  postDebtData,
  fetchModulesDocs,
  uploadModulesDocs,
  moveModulesDocs,
  fetchUploadedModulesDocs,
  deleteModulesDocs,
  fetchFutureLoans,
  fetchLiabilitySum,
  fetchIncomeSum,
  fetchIncomeChartData,
};

export default MODULE_API;
